// Single source of truth for "which observation statuses can be edited".
//
// Editing changes an observation's parameters (targets, exposures, windows,
// etc.). We allow it for states that are halted or retry-able, and refuse it
// for states that are actively executing (NINA may be mid-acquisition) or
// already terminal-done (use Resubmit / Move to Project instead).
//
// Used by ObservationList (the row edit icon + admin action menu) and by the
// ObservationEdit page load guard so all three agree. See observationFilter.js
// for the sibling extraction.
export const EDITABLE_OBS_STATES = [
  'pending',
  'failed',
  'waiting_next',
  'paused',
  'suspended',
  'expired',
];

export const isObservationEditable = (status) => EDITABLE_OBS_STATES.includes(status);
